export default (b) => {
  return b ? 'activo' : 'inactivo'
}


// WEBPACK FOOTER //
// ./src/filters/booleanToState.js